import { create } from "zustand";
import type { User } from "./types";
import type { College } from "./types/colleges";

const testCollege: College = {
  schoolName: "University of Texas at San Antonio",
  division: "NCAA",
  subDivision: "Division I",
  conference: "American Athletic",
  state: "TX",
  licenseStatus: "Approved",
  address: "1 UTSA Circle, San Antonio, TX 78249",
  schoolColors: "0A2240,0A2240,FFFFFF",
  license_royalty: 0.12,
  allowInternational: true,
  artwork_approved: false,
  bulk_created_art: false,
  url: "https://goutsa.com/sports/athletics",
  latitude: "29.583331049999998",
  longitude: "-98.6194450505688",
  school_icon:
    "https://cdn.shopify.com/s/files/1/0646/4664/3925/collections/logo_7b06b5d4-1b6e-4b69-9d13-2643af97b4a9.png?v=1701895873",
  licensing_company: "CLC",
  most_recent: new Date("2/24/2025"),
  tasks: 24,
};

export interface PermissionsMatrix {
  VIEW?: Record<string, boolean>;
  ALTER?: Record<string, boolean>;
}

interface AuthState {
  user: User | null;
  setUser: (user: User | null) => void;
  role: string;
  setRole: (role: string) => void;
  schools: string[];
  setSchools: (schools: string[]) => void;
  userSchools: string[];
  setUserSchools: (userSchools: string[]) => void;
  views: Record<string, string>;
  setViews: (views: Record<string, string>) => void;
  permissions: PermissionsMatrix;
  setPermissions: (permissions: PermissionsMatrix) => void;
  actions: any;
  setActions: (actions: any) => void;
  availableRoles: any[];
  setAvailableRoles: (availableRoles: any[]) => void;
  genderedSportList: string[];
  setGenderedSportList: (genderedSportList: string[]) => void;

  primaryCollege: string | null;
  setPrimaryCollege: (collegeName: string | null) => void;
  primaryCollegeData: College | null;
  setPrimaryCollegeData: (college: College | null) => void;
  resetAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  role: "",
  setRole: (role) => set({ role }),
  schools: [],
  setSchools: (schools) => set({ schools }),
  userSchools: [],
  setUserSchools: (userSchools) => set({ userSchools }),
  views: {},
  setViews: (views) => set({ views }),
  permissions: {},
  setPermissions: (permissions) => set({ permissions }),
  actions: {},
  setActions: (actions) => set({ actions }),
  availableRoles: [],
  setAvailableRoles: (availableRoles) => set({ availableRoles }),
  genderedSportList: [],
  setGenderedSportList: (genderedSportList) => set({ genderedSportList }),

  primaryCollege: null,
  setPrimaryCollege: (primaryCollege) => set({ primaryCollege }),
  primaryCollegeData: null,
  setPrimaryCollegeData: (primaryCollegeData) => set({ primaryCollegeData }),

  resetAuth: () =>
    set({
      user: null,
      role: "",
      schools: [],
      userSchools: [],
      views: {},
      permissions: { VIEW: {}, ALTER: {} },
      actions: {},
      availableRoles: [],
      genderedSportList: [],

      primaryCollege: null,
      primaryCollegeData: null,
    }),
}));

interface CollegeState {
  college: College | null;
  setCollege: (college: College | null) => void;
}

export const useCollegeStore = create<CollegeState>((set) => ({
  college: null,
  setCollege: (college) => set({ college }),
}));
